module.exports = __webpack_public_path__ + "img/car.b5c58e45.png";